import { TableCell, DateCell } from 'ui/tableCell';
import { JsonView } from 'ui/treeView/JsonView';
import { Accordion, AccordionHeader, AccordionContent } from 'ui/accordion';
import type { PurchaseTableColumnData, Purchase } from './types';

export const configureTableColumns = (isUuidBased: boolean): PurchaseTableColumnData[] => {
  return [
    {
      name: isUuidBased ? 'User identifier' : 'User email',
      align: 'flex-start',
      value: isUuidBased ? 'userIdentifier' : 'email',
      RowCell: ({ row }) => <TableCell>{isUuidBased ? row.userIdentifier : row.email}</TableCell>,
    },
    {
      name: 'Created',
      align: 'flex-start',
      value: 'createdAt',
      RowCell: ({ row }) => <DateCell timestamp={row.createdAt} />,
    },
    {
      name: 'Raw data',
      align: 'flex-start',
      sortable: false,
      value: 'stringifiedPurchase',
      RowCell: ({ row }) => (
        <TableCell>
          <Accordion>
            <AccordionHeader>Expand to see raw data</AccordionHeader>
            <AccordionContent>
              <JsonView src={row} collapseByDefault />
            </AccordionContent>
          </Accordion>
        </TableCell>
      ),
    },
  ];
};

export const purchasesFilterFn = (purchase: Purchase, filter: string) => {
  if (purchase.email?.toLowerCase().includes(filter.toLowerCase())) {
    return true;
  }

  if (purchase.userIdentifier?.toLowerCase().includes(filter.toLowerCase())) {
    return true;
  }

  if (purchase.createdAt.includes(filter)) {
    return true;
  }

  return false;
};
